import { Container } from 'inversify-props';

import setupKuspitCustomerDocumentMagicLink from './magic-link/setup';

export default function setupKuspitCustomerDocument(container: Container) {
  setupKuspitCustomerDocumentMagicLink(container);
}
